<div v-if="token_exists" class="card bg-transparent d-none border rounded-5 d-xl-block">
  <h6 class="card-header bg-transparent text-muted">Personal Profiles</h6>

  <div
    v-for="user in filtered_users"
    :key="user.id"
    class="d-flex align-items-center mt-1 p-1 user-row"
    @click="view_profile(user.id)"
  >
    <img
  :src="user.profile_picture || require('@/assets/images/user.svg')"
  class="avatar-xxl rounded-circle border border-2 border-white me-2 profile-list-avatar pointer"
  alt="Profile"
/>
    <p class="mb-1 small fw-500 pointer">
      {{ user.first_name }} {{ user.last_name }}
    </p>
  </div>

  <!-- "See More" link (goes to new page) -->
  <div v-if="users.length > visibleUsersCount" class="overflow-auto p-0 full-width-mobile scrollable-container text-center mt-3">
    <a class="text-decoration-none fs-italic text-xxs" href="/view_personal_profiles">
      See More
    </a>
  </div>
</div>
